import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
//const {name, numDocument, documentType, mail, hasActiveReserve, hasMora, maximumFinancingAmount} = req.body;

const ClientCrudTableRow = ({
                                el,
                                i,
                                editData,
                                deleteData,
                                handleShow,
                                listLines,
                                listLinesByDocumentClient,
                                vinculedLine,
                                setnumDocumentFromModal,
                                setSelectedClient,
                                getVinculedDirections,
                                setModalVincularDireccion,
                                getVinculedEmails,
                                setModalVincularCorreo
                            }) => {
    let myAbilities = HelpAbility();

    let {
        code,
        name,
        lastName,
        numDocument,
        documentType,
        mail,
        hasActiveReserve,
        hasMora,
        hasEntidad,
        maximumFinancingAmount,
        typeClient,
        lines,
        linkedAddresses,
        linkedEmails,
        _id
    } = el;
    console.log({
        linkedEmails
    })

    let documentTypes;
    if (documentType === "CC") {
        documentTypes = "Cedula de Ciudadania";
    } else if (documentType === "CE") {
        documentTypes = "Cedula de Extrangeria";
    }
    maximumFinancingAmount = maximumFinancingAmount.replace(new RegExp("^(\\d{" + (maximumFinancingAmount.length % 3 ? maximumFinancingAmount.length % 3 : 0) + "})(\\d{3})", "g"), "$1 $2").replace(/(\d{3})+?/gi, "$1 ").trim();
    var maximumFinancingAmountFormat = maximumFinancingAmount.replace(/\s+/g, '.')

    const handleChangeSelect = () => {
        setnumDocumentFromModal(numDocument);
        handleShow();
        listLines();
        listLinesByDocumentClient(numDocument);
    }

    const handleLinkDirection = () => {
        setModalVincularDireccion(true);
        setSelectedClient(el);
        getVinculedDirections({mail: el.mail})
    }

    const handleLinkEmail = () => {
        setModalVincularCorreo(true);
        setSelectedClient(el);
        getVinculedEmails({numDocument: el.numDocument})
    }
    return (
        <tr key={code}>
            <th scope="row">{i + 1}</th>
            <td className="text-center">{name}</td>
            <td className="text-center">{lastName}</td>
            <td className="text-center">{numDocument}</td>
            <td className="text-center">{documentTypes}</td>
            <td className="text-center">{mail}</td>
            <td className="text-center">{hasActiveReserve ? 'Si' : 'No'}</td>
            <td className="text-center">{hasMora ? 'Si' : 'No'}</td>
            <td className="text-center">{hasEntidad === undefined ? "Sin asignar" : hasEntidad ? 'Cifin' : 'DataCredito'}</td>
            <td className="text-center">{'$ ' + maximumFinancingAmountFormat}</td>
            <td className="text-center">{typeClient}</td>
            <td className="text-center">{lines}</td>
            <td className="text-center">{linkedAddresses || 0}</td>
            <td className="text-center">{linkedEmails || 0}</td>

            {myAbilities.hasAny([C.A.CUSTOMER.UPDATE, C.A.CUSTOMER.LINK, C.A.CUSTOMER.DELETE, C.A.CUSTOMER.LINKDIRECTION, C.A.CUSTOMER.LINKEMAIL]) &&
            <td className="text-nowrap">
                {myAbilities.has(C.A.CUSTOMER.LINK) && <OverlayTrigger placement="top"
                                                                       overlay={<Tooltip id="tooltip-top">Gestión de
                                                                           Lineas</Tooltip>}>
                    <button type="button"
                            className="btn btn-sm btn-info me-1"
                            onClick={handleChangeSelect}>
                        <i className="bi bi-telephone-fill"/>
                    </button>
                </OverlayTrigger>}
                {myAbilities.has(C.A.CUSTOMER.LINKDIRECTION) && <OverlayTrigger placement="top"
                                                                         overlay={<Tooltip
                                                                             id="tooltip-top">Vincular Direccion</Tooltip>}>
                    <button type="button"
                            className="btn btn-sm btn-info me-1"
                            onClick={handleLinkDirection}>
                        <i class="bi bi-house-door-fill"></i>
                    </button>
                </OverlayTrigger>}

                 {myAbilities.has(C.A.CUSTOMER.LINKEMAIL) && <OverlayTrigger placement="top"
                                                                         overlay={<Tooltip
                                                                             id="tooltip-top">Vincular Correo</Tooltip>}>
                    <button type="button"
                            className="btn btn-sm btn-info me-1"
                            onClick={handleLinkEmail}>
                        <i class="bi bi-envelope-fill"></i>
                    </button>
                </OverlayTrigger>}
                {myAbilities.has(C.A.CUSTOMER.UPDATE) && <OverlayTrigger placement="top"
                                                                         overlay={<Tooltip
                                                                             id="tooltip-top">Editar</Tooltip>}>
                    <button type="button"
                            className="btn btn-sm btn-success me-1"
                            onClick={() => editData(el)}>
                        <i className="bi bi-pencil-square"/>
                    </button>
                </OverlayTrigger>}
                {myAbilities.has(C.A.CUSTOMER.DELETE) && <OverlayTrigger placement="top"
                                                                         overlay={<Tooltip
                                                                             id="tooltip-top">Eliminar</Tooltip>}>
                    <button type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => deleteData(_id)}>
                        <i className="bi bi-trash"/>
                    </button>
                </OverlayTrigger>}
              
            </td>}
        </tr>
    );
}
export default ClientCrudTableRow;
